import { Box, Typography } from "@mui/material";
import { MultimediaPanelView } from "./MultimediaPanelView";

const TabContainorMultiMedia = ({editableEntityData, setEditableEntityData, global_constant, getMultiMediaByEntityId,editableEntityMultimediaData, artists}) => {
        return (
            <Box sx={{p:2}}>
                {/* <Typography fontWeight="bold" sx={{ fontSize: 14, color: 'green' }}>
                    Multimedia Content Here
                </Typography> */}
                <MultimediaPanelView editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} global_constant={global_constant} getMultiMediaByEntityId={getMultiMediaByEntityId} editableEntityMultimediaData={editableEntityMultimediaData} artists={artists}/>
            </Box>
        );
    }

    export default TabContainorMultiMedia;